import React from "react";
import { Provider } from "react-redux";
import { createReduxStore } from "./redux/store";
import Heatmap from "../../views/Heatmap";
import { actionCreators } from "./redux/sagas/heatmap";

const store = createReduxStore("retentionHeatmap");

const HeatmapModule = (props) => {
  const { fetchHeatmapData } = actionCreators;
  const includeCrossRegionalVisits = props.params.sourceType == "clubready" ? { value: true } : "";

  return (
    <Provider store={store}>
      <Heatmap
        {...props}
        fetchHeatmapData={fetchHeatmapData}
        includeCrossRegionalVisits={includeCrossRegionalVisits}
      />
    </Provider>
  );
};

export default HeatmapModule;
